import React, { useState, useRef } from 'react';
import { API_BASE_URL } from '../../helpers/ApiSettings';
import { Editor } from '@tinymce/tinymce-react';

const EditLoisirProductModal = ({ editingProduct, setEditingProduct, onSubmit, onImageDelete }) => {
	const [previewImages, setPreviewImages] = useState([]);
	const editorRef = useRef(null);

	const handleImageChange = (e) => {
		const files = Array.from(e.target.files);
		const previews = files.map(file => ({ url: URL.createObjectURL(file), file }));

		setPreviewImages([...previewImages, ...previews]);
		setEditingProduct({
			...editingProduct,
			newImages: [...(editingProduct.newImages || []), ...files]
		});
	};

	const handleImageDelete = async (imageId, index) => {
		if (window.confirm('Êtes-vous sûr de vouloir supprimer cette image ?')) {
			if (imageId) {
				try {
					await onImageDelete(editingProduct.id, imageId);
				} catch (error) {
					console.error('Error deleting image:', error);
				}
			} else {
				const updatedNewImages = [...(editingProduct.newImages || [])];
				updatedNewImages.splice(index, 1);
				setEditingProduct({ ...editingProduct, newImages: updatedNewImages });
				URL.revokeObjectURL(previewImages[index].url);
				setPreviewImages(prev => prev.filter((_, i) => i !== index));
			}
		}
	};

	return (
		<div className="modal" id="editLoisirProductModal" tabIndex="-1">
			<div className="modal-dialog modal-lg">
				<div className="modal-content">
					{editingProduct && (
						<form onSubmit={onSubmit}>
							<div className="modal-header">
								<h5 className="modal-title">Modifier le produit loisir</h5>
								<button type="button" className="btn-close" data-bs-dismiss="modal"></button>
							</div>
							<div className="modal-body">
								<div className="mb-4">
									<label className="form-label">Images</label>
									<div className="d-flex flex-wrap gap-3 mb-3">
										{editingProduct.images?.map((image, index) => (
											<div key={image.id} className="position-relative" style={{ width: '150px', height: '150px' }}>
												<img
													src={`${API_BASE_URL}${image.url}`}
													alt={`Product ${index + 1}`}
													className="img-thumbnail"
													style={{ width: '100%', height: '100%', objectFit: 'cover' }}
												/>
												<button
													type="button"
													className="btn btn-danger btn-sm position-absolute top-0 end-0"
													onClick={() => handleImageDelete(image.id)}
												>
													×
												</button>
											</div>
										))}

										{previewImages.map((preview, index) => (
											<div key={index} className="position-relative" style={{ width: '150px', height: '150px' }}>
												<img
													src={preview.url}
													alt={`Preview ${index + 1}`}
													className="img-thumbnail"
													style={{ width: '100%', height: '100%', objectFit: 'cover' }}
												/>
												<button
													type="button"
													className="btn btn-danger btn-sm position-absolute top-0 end-0"
													onClick={() => handleImageDelete(null, index)}
												>
													×
												</button>
											</div>
										))}
									</div>

									<input
										type="file"
										className="form-control"
										multiple
										accept="image/*"
										onChange={handleImageChange}
									/>
								</div>

								<div className="mb-3">
									<label className="form-label">Titre</label>
									<input
										type="text"
										className="form-control"
										value={editingProduct.title || ''}
										onChange={(e) => setEditingProduct({ ...editingProduct, title: e.target.value })}
										required
									/>
								</div>

								<div className="row">
									<div className="col-md-6">
										<div className="mb-3">
											<label className="form-label">Référence</label>
											<input
												type="text"
												className="form-control"
												value={editingProduct.reference || ''}
												onChange={(e) => setEditingProduct({ ...editingProduct, reference: e.target.value })}
												required
											/>
										</div>
									</div>
									<div className="col-md-6">
										<div className="mb-3">
											<label className="form-label">Quantité disponible</label>
											<input
												type="number"
												className="form-control"
												value={editingProduct.quantity || 1}
												onChange={(e) => setEditingProduct({ ...editingProduct, quantity: parseInt(e.target.value) })}
												required
												min="0"
												placeholder="Stock disponible"
											/>
											<div className="form-text">
												Nombre d'exemplaires disponibles pour la location
											</div>
										</div>
									</div>
								</div>

								<div className="mb-3">
									<label className="form-label">Âge minimum</label>
									<input
										type="text"
										placeholder='ex.: 2 ans'
										className="form-control"
										value={editingProduct.minimumAge || ''}
										onChange={(e) => setEditingProduct({ ...editingProduct, minimumAge: e.target.value })}
									/>
								</div>

								<div className="mb-3">
									<label className="form-label">Description</label>
									<Editor
										onInit={(evt, editor) => editorRef.current = editor}
										value={editingProduct.description || ''}
										init={{
											height: 300,
											menubar: false,
											plugins: ['lists', 'autolink', 'autoresize', 'help', 'wordcount'],
											toolbar: 'bold italic underline | bullist numlist | removeformat help',
											content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
										}}
										onEditorChange={(content) => {
											setEditingProduct(prev => ({ ...prev, description: content }));
										}}
									/>
								</div>

								<div className="form-check form-switch mb-3">
									<input
										className="form-check-input"
										type="checkbox"
										checked={editingProduct.available}
										onChange={(e) => setEditingProduct({ ...editingProduct, available: e.target.checked })}
									/>
									<label className="form-check-label">
										{editingProduct.available ? 'Disponible' : 'Indisponible'}
									</label>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
									Annuler
								</button>
								<button type="submit" className="btn btn-primary">
									Mettre à jour
								</button>
							</div>
						</form>
					)}
				</div>
			</div>
		</div>
	);
};

export default EditLoisirProductModal;